/**
 * Vue mixin for any common string methods.
 * @author cm359n
 */

import { start } from "@popperjs/core"

export default {
  methods: {
    // Gets the building id (first 3 chars) from a room id
    getBuildingId (roomId) {
      if (roomId) {
        return roomId.substring(0, 3)
      }
    },
    chopSeconds (s) {
      if (s.lastIndexOf(':') != -1) {
        s = s.substring(0, s.lastIndexOf(':'))
      }
      return s
    },
    shortDay (str) {
      let ret = str
      if (ret != null) {
        ret = ret.substring(0, 1) + ret.substring(1, 3).toLocaleLowerCase()
      } else {
        ret = ''
      }
      return ret
    },
    isEmpty (str) {
      if (typeof str === 'undefined') {
        return true
      }
      if (str === null) {
        return true
      }
      if (str === '') {
        return true
      }
      return false
    },
    titleCase (str) {
      let words = str.split(' ')
      let ret = []
      words.forEach((word) => {
        let s = word[0].toLocaleUpperCase() + word.substr(1).toLocaleLowerCase()
        ret.push(s)
      })
      return ret.join(' ')
    },
    caseInsensitiveContains (outer, inner) {
      return this.lc(outer).indexOf(this.lc(inner)) != -1
    },
    lc (str) {
      let ret = ''
      if (typeof str !== 'undefined' && str != null) {
        return str.toLowerCase()
      }
      return ret
    },
    getToday () {
      let ret = new Date()
      ret.setHours(0)
      ret.setMinutes(0)
      ret.setSeconds(0)
      ret.setMilliseconds(0)
      return ret
    },
    advance_range (noweekends, days) {
      let rd = (typeof days !== 'undefined') ? days : 14
      let m = this.getToday()
      let ret = []
      for (let i = 0; i <= rd; i++) {
        let od = this.objectForDate(m)
        if (noweekends == true && (m.getDay() == 0 || m.getDay() == 6)) {
          // do nothing
        } else {
          ret.push(od)
        }
        // m.setTime(m.getTime() + 86400 * 1000) // vulnerable to DST changes
        m.setDate(m.getDate() + 1)
      }
      return ret
    },
    range (start, end) {
      let ret = []
      for (let i = start; i <= end; i++) {
        let hr = (i + '').padStart(2, '0')
        ret.push({ 'display': (i + ':00'), 'value': (hr + ':00') })
        if (i < end) {
          ret.push({ 'display': (i + ':30'), 'value': (hr + ':30') })
        }
      }
      return ret
    },
    nextHalfHour (str) {
      // assume it's in the format 09:00, 15:30 etc
      const hhmm = str.split(/:/)
      let hr = parseInt(hhmm[0])
      let min = parseInt(hhmm[1])
      if (min == 0) {
        min = 30
      } else {
        min = 0
        hr++
      }
      const hrdisp = hr.toString().padStart(2, '0')
      const mindisp = min.toString().padStart(2, '0')
      return hrdisp + ':' + mindisp
    },
    hoursMinutes (str) {
      let hhmm = str.split(/:/)
      if (hhmm.length == 2) {
        return (parseInt(hhmm[0]) * 60 + parseInt(hhmm[1]))
      }
      return null
    },
    timeDispUnit (num) {
      return (num + '').padStart(2, '0')
    },
    dateFromEpochMs (str) {
      let ret = new Date()
      ret.setTime(str)
      return ret
    },
    replaceWeirdChars (str) {
      let ret = str
      if (typeof str !== 'undefined' && str != null) {
        ret = str.replace(/Ã©/, 'e')
      }
      return ret
    },
    displayEventInfo (sd, ed, st, et) {
      /*
      We have 4 cases here:
      1. start date, start time, end time given
      2. start date, end date given
      3. start date, end date, start time given
      4. start date, end date, start time and end time given

      need start date
      | need end date UNLESS we have start & end times
      | if have start time, display it
      | | if have end time too, display that too
      */
      let ret = { date: '', time: '' }
      const empty = this.isEmpty
      const startDate = this.displayDate(sd)
      const endDate = this.displayDate(ed)
      const startTime = st
      const endTime = et
      if (!empty(startDate)) {
        ret.date = startDate
        if (!empty(endDate) && endDate != startDate) {
          ret.date += ' - ' + endDate
          if (!empty(startTime)) {
            ret.time = startTime
            if (!empty(endTime)) {
              ret.time += ' - ' + endTime
            }
          }
        } else {
          // if no endDate, we have to have both start and end times
          if (!empty(startTime) && !empty(endTime)) {
            ret.time = startTime + ' - ' + endTime
          } else if (!empty(startTime)) {
            ret.time = startTime
          }
        }
      }
      return ret
    },
    displayKeyDateInfo (sd, ed) {
      /*
      Always have start date and end date
      May be the same dates for a one-day key date
      */
      let ret = { date: '', time: '' }
      const empty = this.isEmpty
      const startDate = this.displayKeyDate(sd)
      const endDate = this.displayKeyDate(ed)
      if (!empty(startDate)) {
        ret.date = startDate
        if (!empty(endDate) && endDate != startDate) {
          ret.date += ' - ' + endDate
        }
      }
      return ret
    },
    displayDate (d) {
      // date should be of the form yyyy-mm-dd
      // required format is 'Friday 20 May 2021'
      let ret = ''
      if (!(this.isEmpty(d))) {
        let dte = new Date(d)
        let disp = this.objectForDate(dte)
        ret = disp['display']
      }
      return ret
    },
    displayKeyDate (d) {
      // required format is 'Fri 20 May 2021'
      let ret = ''
      if (!(this.isEmpty(d))) {
        let dte = new Date(d)
        let disp = this.objectForDate(dte)
        ret = disp['keyDate']
      }
      return ret
    },
    objectForDate (dte) {
      /* Avoid adding things here unless toLocaleDateString
         (see DATE AND TIME FORMATS below) doesn't do what you want */
      let dateYyyy = (dte.getYear() + 1900) + ''
      let dateMm = (dte.getMonth() + 1) + ''
      let dateDd = (dte.getDate() + '')
      let dtDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dte.getDay()]
      let dtDayFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dte.getDay()]
      let dtDate = dateDd.padStart(2, '0')
      let dtMon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][dte.getMonth()]
      let dtMonFull = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'][dte.getMonth()]
      let dispDate = dtDay + ' ' + dtDate + ' ' + dtMon
      let YmdDate = dateYyyy + '-' + dateMm.padStart(2, '0') + '-' + dateDd.padStart(2, '0')
      let oracleDate = dtDate + ' ' + dtMon + ' ' + dte.getFullYear()
      let eventDate = dtDayFull + ' ' + dtDate + ' ' + dtMonFull + ' ' + dte.getFullYear()
      let afDate = dtDayFull + ', ' + dateDd + ' ' + dtMonFull + ' ' + dte.getFullYear()
      let keyDate = dtDay + ' ' + dtDate + ' ' + dtMon + ' ' + dte.getFullYear()
      let ret = {
        'display': dispDate, // Wed 15 Oct
        'oracleDate': oracleDate, // 15-Oct-20
        'eventDate': eventDate, // Wednesday 15 October 2020
        'afDate': afDate, // Wednesday, 15 October, 2020
        'keyDate': keyDate, // Wed 15 Oct 2020
        'value': dte.getTime(),
        'Ymd': YmdDate
      }
      return ret
    },
    // Sort a room string, which is of the form "6 Professors' Square:230 (G30)".
    // It is meant to be fed into an array sort, like so: foo.sort(this.roomSort)

    // Sort order is number (if present), address, then room
    // And number should be sorted in numerical order, not alphabetical order...
    roomSort (a, b) {
      let termregex = /^([^:]+):(.*)$/
      let roomregex = /^(\d+)/

      let term1 = a[1].match(termregex)
      let term2 = b[1].match(termregex)
      let matchFailed = false
      if (term1 == null) {
        console.log('match for ' + a[1] + ' failed')
        matchFailed = true
      }
      if (term2 == null) {
        console.log('match for ' + b[1] + ' failed')
        matchFailed = true
      }
      if (matchFailed) {
        if (a === b) {
          return 0
        } else {
          return a > b ? 1 : -1
        }
      }

      // the 'building' may have a number in it - try to sort on that numerically
      let building1 = term1[1]
      let building2 = term2[1]
      let room1 = term1[2]
      let room2 = term2[2]

      let nb1 = building1.split(roomregex)
      let nb2 = building2.split(roomregex)
      let number1 = ''
      if (nb1.length > 1) {
        number1 = parseInt(nb1[1])
        if (isNaN(number1)) {
          number1 = 0
        }

        building1 = nb1[2]
      }
      let number2 = ''
      if (nb2.length > 1) {
        number2 = parseInt(nb2[1])
        if (isNaN(number2)) {
          number2 = 0
        }
        building2 = nb2[2]
      }
      // Comment these out unless you're debugging regex matches
      // console.log('Number: ' + number1 + ', Building: ' + building1 + ', Room: ' + room1)
      // console.log('Number: ' + number2 + ', Building: ' + building2 + ', Room: ' + room2)
      if (building1 === building2) {
        if (number1 === number2) {
          if (room1 === room2) {
            return 0
          } else {
            return room1 > room2 ? 1 : -1
          }
        } else {
          return number1 > number2 ? 1 : -1
        }
      }
      return building1 > building2 ? 1 : -1
    },
    // DATE AND TIME FORMATS
    // There are lots of different date formats in the app
    // so please search the below to see if yours is there
    // before adding a new one :-)
    formatLongDateForAF (seconds) { // format Wednesday, 23 March 2022
      /* var options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        weekday: 'long'
      } */
      // unfortunately some browsers return Wednesday, March 23, 2022
      // EVEN THOUGH i specify en-GB!! :-(
      // and tests fail, so i use my own formatter here
      const d = new Date(seconds * 1000)
      const dteObj = this.objectForDate(d)

      return dteObj['afDate']
    },
    formatDate (seconds) { // format 23 Mar 2022
      var options = { year: 'numeric', month: 'short', day: 'numeric' }
      return this.formatSpecificDateFormat(seconds, options)
    },
    formatDateTime (seconds) { // format 23 Mar 2022, 22:00
      var options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric' }
      return this.formatSpecificDateFormat(seconds, options)
    },
    formatTime (seconds) { // format 22:00
      var options = { hour: '2-digit', minute: 'numeric' }
      return this.formatSpecificTimeFormat(seconds, options)
    },
    formatSpecificTimeFormat (seconds, options) {
      var date = new Date()
      date.setTime(seconds * 1000)
      var timeString = date.toLocaleTimeString('en-GB', options)
      return timeString
    },
    formatSpecificDateFormat (seconds, options) {
      var date = new Date()
      date.setTime(seconds * 1000)
      var dateString = date.toLocaleDateString('en-GB', options)
      return dateString
    },
    onlyUnique (value, index, self) { // use for filters e.g. mylist.filter(this.onlyUnique)
      return self.indexOf(value) === index
    },
    upToFirst (str, ch) {
      // renders string str up to the first occurrence of ch.
      let ret = str
      const ind = str.indexOf(ch)
      if (ind != -1) {
        ret = str.substring(0, ind)
      }
      return ret
    },
    async makeHash (obj) {
      const string = JSON.stringify(obj)
      const utf8 = new TextEncoder().encode(string)
      const hashBuffer = await crypto.subtle.digest('SHA-256', utf8)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('')
      return hashHex
    }
  }
}
